import { userPermissions } from "@redotech/redo-model/permissions";
import { ManagedUserRolesArray } from "@redotech/redo-model/roles";
import { roleColor } from "@redotech/redo-model/user-role";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const baseRole = z.object({
  userIds: z.array(zExt.objectId()),
  permissions: z.array(createEnum(userPermissions)),
  isManagedRole: z.boolean(),
});

const managedRole = baseRole.extend({
  id: createEnum(ManagedUserRolesArray),
  isManagedRole: z.literal(true),
});

const userDefinedRole = baseRole.extend({
  name: z.string(),
  isManagedRole: z.literal(false),
  roleColor: createEnum(roleColor),
});

const roleInput = z.union([managedRole, userDefinedRole]);
export type RoleInputSchema = z.infer<typeof roleInput>;

export const upsertUserRole = {
  name: "upsertUserRole" as const,
  input: roleInput,
  output: z.null(),
};
